import {Directive, ElementRef, Input, OnChanges, SimpleChanges} from "@angular/core";

@Directive({
    selector: "[wbo-css-var]"
})
export class CssVarDirective implements OnChanges {

    @Input("wbo-css-var") cssVars: any = {};

    constructor(private element: ElementRef) {
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes["cssVars"]) {
            Object.keys(this.cssVars).forEach((varName) => {
                const value: any = this.cssVars[varName];
                if (Array.isArray(value)) {
                    const values: string[] = value.slice();
                    let apply: boolean = true;
                    if (values.length > 1 && typeof values[0] === "string") {
                        if (values[0].startsWith("?")) {
                            const checkVarName: string = values.shift().substr(1);
                            const checkValue: string = getComputedStyle(this.element.nativeElement).getPropertyValue(checkVarName);
                            if (checkValue === undefined || checkValue === "") {
                                apply = false;
                            }
                        } else if (values[0].startsWith("!")) {
                            const checkVarName: string = values.shift().substr(1);
                            const checkValue: string = getComputedStyle(this.element.nativeElement).getPropertyValue(checkVarName);
                            if (checkValue !== undefined && checkValue !== "") {
                                apply = false;
                            }
                        }
                    }
                    if (apply) {
                        values.some((val) => this.applyValue(varName, val));
                    } else {
                        this.element.nativeElement.style.removeProperty(varName);
                    }
                } else {
                    this.applyValue(varName, value);
                }
            });
        }
    }

    applyValue(varName: string, value: any): boolean {
        if (value === undefined) {
            this.element.nativeElement.style.removeProperty(varName);
            return true;
        }

        if (typeof value === "string" && value.startsWith("--")) {
            const otherValue: string = getComputedStyle(this.element.nativeElement).getPropertyValue(value);
            if (otherValue === undefined || otherValue === "") {
                this.element.nativeElement.style.removeProperty(varName);
                return false;
            }

            this.element.nativeElement.style.setProperty(varName, otherValue);
            return true;
        }

        this.element.nativeElement.style.setProperty(varName, value);
        return true;
    }
}
